<template>
  <div>
    <el-select :value="value" value-key="key" :size="size" :disabled="disabled" :placeholder="$t('table.status')" @input="change($event)" :clearable="true">
      <el-option v-for="item in options" :key="item.key" :label="item.value" :value="item" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      emptyValue: { key: -1 },
      options: [{key: 0, value: '待审批'}, {key: 1, value: '审批通过'}, {key: 2, value: '审批不通过'}]
    }
  },
  props: ['value', 'config', 'size', 'disabled', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/ApprovalSelect.vue